import Color from "color";
import { css } from "styled-components";
import { getBackgroundColor } from "../_themes/helpers";

export const breakpoints = {
  xsmall: 480,
  small: 576,
  medium: 768,
  large: 992,
  xlarge: 1200
};

export const IE11Only = style => {
  return css`
    @media all and (-ms-high-contrast: none) {
      *::-ms-backdrop,
      & {
        ${style};
      }
    }
  `;
};

export const iPadOnly = style => {
  return `
    /* iPad 1, 2, Mini and Air */
    @media only screen
      and (min-device-width: 768px)
      and (max-device-width: 1024px)
      and (-webkit-device-pixel-ratio: 1) {
        & {
          ${style};
        }
    }
    /* iPad 3, 4 and Pro 9.7" */
    @media only screen
      and (min-device-width: 768px)
      and (max-device-width: 1024px)
      and (-webkit-device-pixel-ratio: 2) {
        & {
          ${style};
        }
    }
    /* iPad Pro 10.5" */
    @media only screen
      and (min-device-width: 834px)
      and (max-device-width: 1112px)
      and (-webkit-device-pixel-ratio: 2) {
        & {
          ${style};
        }
    }
  `;
};

export const iPadPortraitOnly = style => {
  return `
    /* iPad 1, 2, Mini and Air */
    @media only screen
      and (min-device-width: 768px)
      and (max-device-width: 1024px)
      and (orientation: portrait)
      and (-webkit-device-pixel-ratio: 1) {
        & {
          ${style};
        }
    }
    /* iPad 3, 4 and Pro 9.7" */
    @media only screen
      and (min-device-width: 768px)
      and (max-device-width: 1024px)
      and (orientation: portrait)
      and (-webkit-device-pixel-ratio: 2) {
        & {
          ${style};
        }
    }
    /* iPad Pro 10.5" */
    @media only screen
      and (min-device-width: 834px)
      and (max-device-width: 1112px)
      and (orientation: portrait)
      and (-webkit-device-pixel-ratio: 2) {
        & {
          ${style};
        }
    }
  `;
};

export const iPadLandscapeOnly = style => {
  return `
    /* iPad 1, 2, Mini and Air */
    @media only screen
      and (min-device-width: 768px)
      and (max-device-width: 1024px)
      and (orientation: landscape)
      and (-webkit-device-pixel-ratio: 1) {
        & {
          ${style};
        }
    }
    /* iPad 3, 4 and Pro 9.7" */
    @media only screen
      and (min-device-width: 768px)
      and (max-device-width: 1024px)
      and (orientation: landscape)
      and (-webkit-device-pixel-ratio: 2) {
        & {
          ${style};
        }
    }
    /* iPad Pro 10.5" */
    @media only screen
      and (min-device-width: 834px)
      and (max-device-width: 1112px)
      and (orientation: landscape)
      and (-webkit-device-pixel-ratio: 2) {
        & {
          ${style};
        }
    }
  `;
};

export const FirefoxOnly = style => {
  return css`
    @-moz-document url-prefix() {
      ${style};
    }
  `;
};

export const hoverSupported = style => css`
  /* "ms-high-contrast" is used to target IE11 */
  @media not all and (pointer: coarse), (-ms-high-contrast: none) {
    ${style};
  }
`;

export const topGradient = css`
  &:before {
    content: "";
    position: absolute;
    z-index: 1;
    top: 0;
    width: 100%;
    height: 2em;
    display: block;
    pointer-events: none;
    background: linear-gradient(
      to bottom,
      ${getBackgroundColor("settingsWindow")} 10%,
      ${({ theme }) =>
          Color(getBackgroundColor("settingsWindow")({ theme }))
            .alpha(0)
            .string()}
        100%
    );
  }
`;

export const bottomGradient = css`
  &:after {
    content: "";
    position: absolute;
    bottom: -1px; /* Otherwise there is a gap */
    left: 0;
    right: 0;
    width: 100%;
    height: 2em;
    margin: 0;
    display: block;
    pointer-events: none;
    background: linear-gradient(
      to top,
      ${getBackgroundColor("settingsWindow")} 10%,
      ${({ theme }) =>
          Color(getBackgroundColor("settingsWindow")({ theme }))
            .alpha(0)
            .string()}
        100%
    );
  }
`;
